export default __webpack_public_path__ + "static/media/image2.97e00022.png";